import React, { Fragment, useContext, useEffect } from "react";
// Provider
import { AppContext, SET_BS_UNIT } from "../../components/AppProvider";

// Utils

// UI
import { PostApi1914 } from "../../modules/network/padoPost";
import { Container } from "../Layout";
import useTitle from "../../modules/hooks/useTitle";
export default props => {
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);
  useTitle("마이페이지_설정_혈당단위설정");

  // useEffect(() => {
  const request1914 = (setColumn, setValue, hpKey) => {
    PostApi1914(userinfo, cfg, phonecfg, setColumn, setValue, hpKey)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const setUnit = e => {
    $("input[type=radio]").each(function () {
      if (this.checked) {
        let data = this.id == "mmolL" ? "mmol/L" : "mg/dL";
        dispatch({ type: SET_BS_UNIT, data: data });
        request1914("bsUnit", data, "");
      }
    });
  };

  useEffect(() => {
    if (
      !userinfo.app ||
      !userinfo.app.setInfo ||
      !userinfo.app.setInfo.bsUnit ||
      userinfo.app.setInfo.bsUnit === "mg/dL"
    )
      $("#mgdL").attr("checked", true);
    else if (userinfo.app.setInfo.bsUnit === "mmol/L")
      $("#mmolL").attr("checked", true);
  }, []);
  return (
    <Fragment>
      <Container
        Title={"혈당 단위설정"}
        dark={"dark"}
        isMain={false} /*bottom={list.length === 0 ? <Bottom /> : null}*/
      >
        <div className="contents">
          <div className="sub-contents">
            <div className="device-link-contain type3">
              <div>
                <div className="round-list">
                  <div className="title">혈당 단위설정</div>
                  <div className="rd-box">
                    mg/dL
                    <label className="radio-checked">
                      <input
                        type="radio"
                        name="radio1"
                        id="mgdL"
                        onClick={setUnit}
                      />
                      <i></i>
                    </label>
                  </div>
                  <div className="rd-box">
                    mmol/L
                    <label className="radio-checked">
                      <input
                        type="radio"
                        name="radio1"
                        id="mmolL"
                        onClick={setUnit}
                      />
                      <i></i>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};
